<router-outlet />

<ngx-spinner
  bdColor="rgba(0, 0, 0, 0.8)"
  size="medium"
  color="#fff"
  type="ball-scale-pulse"
  [fullScreen]="true"
  ><p style="color: white">Loading...</p></ngx-spinner
>
<app-confirm-dialog></app-confirm-dialog>
<app-confirm-dailog-token></app-confirm-dailog-token>
